import { render, staticRenderFns } from "./ImageWrapper.vue?vue&type=template&id=01877b24&scoped=true"
import script from "./ImageWrapper.vue?vue&type=script&lang=ts"
export * from "./ImageWrapper.vue?vue&type=script&lang=ts"
import style0 from "./ImageWrapper.vue?vue&type=style&index=0&id=01877b24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01877b24",
  null
  
)

export default component.exports